import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GlobalsService {

    dict = {};

    constructor() {
    }

    public get(key: string): any {
        if (this.dict.hasOwnProperty(key)) {
            return this.dict[key];
        } else {
            return undefined;
        }
    }

    public set(key: string, value: any, overwrite: boolean = true): boolean {
        if (overwrite || !this.dict.hasOwnProperty(key)) {
            this.dict[key] = value;
            return true;
        } else {
            return false;
        }
    }
}
